//https://react-hook-form.com/form-builder
// https://emojipedia.org
import React from "react";
import { useState, useEffect, useMemo } from "react";
import { useTable, useSortBy } from "react-table";
import {
  userGrid,
  generateCSV,
  generateXLSX,
  generateAllBadges,
  generateAllBadges4slice,
} from "../components/FuncUtils";

function UsersGrid() {
  const [data, setData] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(25);
  const [totalCount, setTotalCount] = useState(0);

  const pageCount = Math.ceil(totalCount / pageSize);

  const getRowStyle = (index) => ({
    backgroundColor: index % 2 === 0 ? "#eeeeee" : "#dddddd",
    color: "#000000",
  });

  const caseInsensitiveSort = (rowA, rowB, columnId, desc) => {
    const a = String(rowA.values[columnId] || "").toLowerCase();
    const b = String(rowB.values[columnId] || "").toLowerCase();

    if (a > b) return 1;
    if (a < b) return -1;
    return 0;
  };

  const fetchUsers = async (page, limit) => {
    setLoading(true);
    try {
      const response = await userGrid(page, limit);

      setData(JSON.parse(response).users);
      //setData(response.data.users);
      setTotalCount(JSON.parse(response).totalCount);
      //console.log("Données récupérées :", JSON.parse(response).users);
    } catch (err) {
      console.error("Erreur de récupération :", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(pageIndex, pageSize);
  }, [pageIndex, pageSize]);

  const columns = useMemo(
    () => [
      { Header: "Nom", accessor: "lastname", sortType: caseInsensitiveSort },
      {
        Header: "Prénom",
        accessor: "firstname",
        sortType: caseInsensitiveSort,
      },
      { Header: "Email", accessor: "email", sortType: caseInsensitiveSort },
      {
        Header: "Société",
        accessor: "organization",
        sortType: caseInsensitiveSort,
      },
      {
        Header: "Dîner",
        accessor: "dinnerReservation",
        sortType: caseInsensitiveSort,
      },
      {
        Header: "Végie",
        accessor: "vegetarianMeal",
        sortType: caseInsensitiveSort,
      },
      { Header: "Membre", accessor: "bappMember" },
      {
        Header: "Inscrit le",
        accessor: "createdAt",
        Cell: ({ value }) => {
          if (!value?._seconds) return "";

          const date = new Date(value._seconds * 1000);

          //return date.toLocaleString(); // ou `dayjs(date).format(...)`
          return date.toLocaleDateString();
        },
      },
      {
        Header: "Confirmé",
        accessor: "emailSent",
        Cell: ({ value }) => {
          if (!value?._seconds) {
            return "❌";
          } else {
            return "✅";
          }

          const date = new Date(value._seconds * 1000);
          return date.toLocaleString(); // ou `dayjs(date).format(...)`
        },
      },

      {
        Header: " ",
        Cell: ({ row }) => (
          <div style={{ display: "flex", gap: "5px" }}>
            {/*<button onClick={() => handleEdit(row.original)}>✏️</button>
            <button onClick={() => handleDelete(row.original)}>🗑️</button>
            <button onClick={() => handleView(row.original)}>👁️</button>
            <button onClick={() => handleCheck(row.original)}>✅</button> */}
            <button onClick={() => handleMail(row.original)}>✉️</button>
          </div>
        ),
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useSortBy);

  const getVisiblePages = () => {
    const maxVisible = 5;
    let start = Math.max(0, pageIndex - 2);
    let end = Math.min(pageCount, start + maxVisible);

    if (end - start < maxVisible) {
      start = Math.max(0, end - maxVisible);
    }

    return Array.from({ length: end - start }, (_, i) => start + i);
  };

  const handleEdit = (user) => {
    alert(`Éditer : ${user.firstname}`);
  };

  const handleDelete = (user) => {
    alert(`Supprimer : ${user.firstname}`);
  };

  const handleView = (user) => {
    alert(`Voir : ${user.workAdr}`);
  };

  const handleCheck = (user) => {
    alert(`Check : ${user.email} `);
  };

  const handleMail = (user) => {
    sessionStorage.setItem("userToMail", JSON.stringify(user));

    window.open("/mail", "_blank");

    /* navigate("/mail", {
      state: { user },
    });*/
  };

  const exp = localStorage.getItem("expiresAt");
  const expiry = new Date(exp * 1);
  const expiresAt = expiry.toLocaleString("fr-BE", {
    timeZone: "Europe/Brussels",
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return (
    <div style={{ padding: "2rem" }}>
      {/*}
      <div>
        <p style={{ fontSize: "10px" }}>/{getJwtData()}/</p>
      </div>
      <div>
        <p style={{ fontSize: "10px" }}>/{getRefreshTokenData()}/</p>
      </div>
      <div>
        <p style={{ fontSize: "10px" }}>/{expiresAt}/</p>
      </div>
*/}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <h2>Liste des inscrits</h2>

        <div>
          <label style={{ marginRight: "0.5rem" }}>Éléments par page :</label>
          <select
            value={pageSize}
            onChange={(e) => {
              setPageSize(parseInt(e.target.value));
              setPageIndex(0); // reset à la première page
            }}
          >
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={250}>250</option>
            <option value={500}>500</option>
            <option value={1000}>1000</option>
          </select>
        </div>
        <div>
          <button
            type="submit"
            onClick={() => {
              window.location.href = "/logout";
            }}
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "5px",
            }}
          >
            {"Se déconnecter"}
          </button>
        </div>
        {/*} <div>
          <button
            type="submit"
            onClick={() => {
              getValidIdToken();
            }}
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "5px",
            }}
          >
            {"refresh token"}
          </button>
        </div> */}
      </div>

      {loading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
            background: "rgba(0,0,0,0.6)",
            padding: "1rem 2rem",
            borderRadius: "8px",
            color: "#fff",
            fontWeight: "bold",
          }}
        >
          ⏳ Chargement...
        </div>
      )}

      <table
        {...getTableProps()}
        style={{ width: "100%", borderCollapse: "collapse" }}
      >
        <thead>
          {headerGroups.map((headerGroup) => {
            const { key: groupKey, ...groupProps } =
              headerGroup.getHeaderGroupProps();

            return (
              <tr key={groupKey} {...groupProps}>
                {headerGroup.headers.map((column) => {
                  // const { key: columnKey, ...columnProps } =
                  //   column.getHeaderProps();
                  const { key: columnKey, ...columnProps } =
                    column.getHeaderProps(column.getSortByToggleProps({title: "Trier",}));

                  return (
                    <th
                      key={columnKey}
                      {...columnProps}
                      style={{ textAlign: "left", cursor: "pointer" }}
                    >
                      {column.render("Header")}
                      <span>
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            " 🔽"
                          ) : (
                            " 🔼"
                          )
                        ) : (
                          <span style={{ opacity: 0.4 }}> ⇅</span>
                        )}
                      </span>
                    </th>
                  );
                })}
              </tr>
            );
          })}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);

            // Cacher le compte admin de l'app
            {
              /*const firstnameCell = row.cells.find(
              (cell) => cell.column.id === "firstname"
            );
            if (firstnameCell.value === "Entrance") return null; */
            }

            const { key: rowKey, ...rowProps } = row.getRowProps();
            return (
              <tr key={rowKey} {...rowProps} style={getRowStyle(i)}>
                {row.cells.map((cell) => {
                  const { key: cellKey, ...cellProps } = cell.getCellProps();

                  return (
                    <td key={cellKey} {...cellProps} style={{ padding: "8px" }}>
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>

      <div
        style={{
          marginTop: "1rem",
          display: "flex",
          justifyContent: "center",
          gap: "6px",
        }}
      >
        <button onClick={() => setPageIndex(0)} disabled={pageIndex === 0}>
          «
        </button>
        <button
          onClick={() => setPageIndex((p) => Math.max(0, p - 1))}
          disabled={pageIndex === 0}
        >
          ‹
        </button>
        {getVisiblePages().map((page) => (
          <button
            key={page}
            onClick={() => setPageIndex(page)}
            style={{
              fontWeight: page === pageIndex ? "bold" : "normal",
              textDecoration: page === pageIndex ? "underline" : "none",
              backgroundColor: page === pageIndex ? "#222" : "#fff",
              color: page === pageIndex ? "#fff" : "#000",
              border: "1px solid #ccc",
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {page + 1}
          </button>
        ))}
        <button
          onClick={() => setPageIndex((p) => Math.min(pageCount - 1, p + 1))}
          disabled={pageIndex === pageCount - 1}
        >
          ›
        </button>
        <button
          onClick={() => setPageIndex(pageCount - 1)}
          disabled={pageIndex === pageCount - 1}
        >
          »
        </button>

        <button onClick={() => generateXLSX()}>Télécharger fichier XLSX</button>
        <button onClick={() => generateAllBadges()}>
          Télécharger la liste des badges
        </button>
         <button onClick={() => generateAllBadges4slice()}>
          Télécharger la liste des badges pour la découpe
        </button>

      </div>
    </div>
  );
}

export default UsersGrid;
